import React, { useState, useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { registerConfirmHandler, ConfirmRequest } from '../../lib/confirm';
import { MIcon } from '../../lib/micon';
import '../ld/ld-fenster.css';

// Einmal am App-Root gemountet (neben dem Toast-Host). Rendert den von confirm()
// angeforderten Dialog und löst das Promise mit der Nutzer-Entscheidung auf.
export function ConfirmHost() {
  const [req, setReq] = useState<ConfirmRequest | null>(null);

  useEffect(() => {
    registerConfirmHandler(setReq);
    return () => registerConfirmHandler(null);
  }, []);

  const schliessen = useCallback((wert: boolean) => {
    setReq(prev => { prev?.resolve(wert); return null; });
  }, []);

  useEffect(() => {
    if (!req) return;
    // Welle D3b: in der Capture-Phase und ohne Weitergabe — Esc schließt NUR den Dialog,
    // nicht zusätzlich darunterliegende Ebenen (Board-Bearbeiten, Menüs, Sheets)
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') { e.stopImmediatePropagation(); e.preventDefault(); schliessen(false); }
      else if (e.key === 'Enter' && !(document.activeElement instanceof HTMLButtonElement)) { e.stopImmediatePropagation(); e.preventDefault(); schliessen(!req.danger); }
    };
    window.addEventListener('keydown', onKey, true);
    return () => window.removeEventListener('keydown', onKey, true);
  }, [req, schliessen]);

  if (!req) return null;

  // Welle D3b: per Portal direkt in <body> — sonst kann ein Vorfahr mit transform/filter
  // (Board-Widgets, Sheets) das fixed-Overlay einsperren. pointerdown nicht weiterreichen,
  // sonst hält ein darunterliegendes vaul-Sheet den Klick für „außerhalb“ und schließt sich.
  return createPortal(
    <div
      onPointerDown={e => e.stopPropagation()}
      onClick={() => schliessen(false)}
      className="ld-modal-overlay"
      // pointerEvents: modale Sheets (vaul/Radix) setzen body{pointer-events:none} — der
      // Dialog muss trotzdem bedienbar bleiben
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 3000, pointerEvents: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}
    >
      {/* Welle Z3: K4-Rahmen (Kopf mit rundem Schließen-Knopf, Fußleiste). Bei Gefahr ist „Abbrechen“ vorausgewählt. */}
      <div onClick={e => e.stopPropagation()} role="alertdialog" aria-modal="true" aria-labelledby="ld-confirm-titel" aria-describedby="ld-confirm-text" className="ld-z3-dialog">
        <div className="ld-fe-kopf">
          <div className="ld-fe-kopf__text"><h3 id="ld-confirm-titel" className="ld-fe-kopf__titel">{req.title ?? 'Bitte bestätigen'}</h3></div>
          <button type="button" className="ld-fe-zu" aria-label="Schließen" onClick={() => schliessen(false)}><MIcon name="close" size={20} /></button>
        </div>
        <p id="ld-confirm-text" className="ld-z3-dialog__text">{req.message}</p>
        <div className="ld-fe-fuss">
          <button type="button" className="ld-fe-knopf ld-fe-knopf--zweit" autoFocus={!!req.danger} onClick={() => schliessen(false)}>{req.cancelLabel ?? 'Abbrechen'}</button>
          <button type="button" className={`ld-fe-knopf ld-fe-knopf--haupt${req.danger ? ' ist-gefahr' : ''}`} autoFocus={!req.danger} onClick={() => schliessen(true)}>{req.confirmLabel ?? 'Bestätigen'}</button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
